import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { TranslationService } from "../../../_services/translation.service";
import { NoalGlobalData } from "../../../_services/eventsServices/events.service";
import { UserManagementService } from "../../../_services/user-management.service";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { UserPrivilegeType } from "../user-management-models/user-privilege-type.enum";
import { EventOrgan } from "../../events-screen/create-parent-event-form-pricing-nests/create-parent-event-form-pricing-nests.component";
import { Layer } from "../../events-screen/event-page-models/noal.models";
import { UserNoalOrgan } from "../user-management-models/user-noal-organ";
import { UserFormErrorsEnum } from "../user-management-models/user-form-errors.enum";

@Component({
  selector: "user-management-form-activity-fields",
  templateUrl: "./user-management-form-activity-fields.component.html",
  styleUrls: [
    "../../events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.scss",
    "./user-management-form-activity-fields.component.scss",
  ],
})
export class UserManagementFormActivityFieldsComponent
  implements AfterViewInit, OnInit
{
  @Input("userId")
  public userId: "new" | string = "new";
  @Input("showLayers") public showLayers = false;
  @Input("isOnlyActivityFields") public isOnlyActivityFields = false;
  public translations$: Observable<ITranslations>;
  public areLimitedPrivilegesShown = false;
  public hasExtraUnseenPermission = false;
  public cannotAddDifferentOrganTypesError = false;
  public showAdditionalInfoAboutPermissions = false;
  public selectedOrgans: UserNoalOrgan[] = [];
  public availableOrgans: UserNoalOrgan[] = [];
  // This is needed only for grades. The other data is not needed.
  public layerCollection: NoalGlobalData;
  public readonly LayersList: Layer[] = [];
  public activityFieldsForm: FormGroup;

  constructor(
    private translationService: TranslationService,
    private usesManagementService: UserManagementService,
    private userActivityFieldsForm: FormGroupDirective
  ) {
    this.translations$ = this.translationService.translations;
  }

  @Input("layerCollectionGlobalData")
  public set gradesCollectionGlobalData(value: any) {
    // tslint:disable-next-line:curly
    if (!value) {
      return;
    }
  }

  get eventLayersControls() {
    return (this.activityFieldsForm.get("userFormLayers") as FormArray)
      .controls as FormControl[];
  }

  public trackByFn(index: any, item: any) {
    return index;
  }
  public ngOnInit() {
    this.activityFieldsForm = this.userActivityFieldsForm.form;
    this.initPage().then();
  }

  public ngAfterViewInit() {}

  public updateSelectedOrgans($event: UserNoalOrgan[]) {
    const allOrganTypes = new Set(
      $event.filter((o) => o.status !== "deleted").map((o) => o.organType)
    );
    this.cannotAddDifferentOrganTypesError = allOrganTypes.size > 1;
    this.activityFieldsForm.controls["userSelectedOrgans"].patchValue($event);
    this.activityFieldsForm.controls["userSelectedOrgans"].setErrors(
      this.cannotAddDifferentOrganTypesError
        ? {
            [UserFormErrorsEnum.BadOrganPrevaliges]:
              UserFormErrorsEnum.BadOrganPrevaliges,
          }
        : null
    );
  }

  public layerClicked() {}

  public devCheckFormStatus() {}

  private async initPage() {
    const formValues = this.activityFieldsForm.value;

    const userFormLayers = formValues.userFormLayers;
    const userSelectedOrgans = formValues.userSelectedOrgans as UserNoalOrgan[];
    const availableOrgans = formValues.availableOrgans as UserNoalOrgan[];

    this.selectedOrgans = userSelectedOrgans || [];
    this.availableOrgans = availableOrgans || [];
    this.hasExtraUnseenPermission = formValues.has_extra_unseen_permission;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-form-activity-fields/user-management-form-activity-fields.component.ts